export const TIMEZONES = [
	{ label: 'UTC', value: 'UTC' },
	{ label: 'CET / CEST (Berlin, Paris, Madrid)', value: 'Europe/Berlin' },
	{ label: 'EET / EEST (Helsinki, Kyiv, Riga)', value: 'Europe/Helsinki' },
	{ label: 'WET / WEST (Lisbon, Canary Islands)', value: 'Atlantic/Canary' },
	{ label: 'GMT / BST (London, Dublin)', value: 'Europe/London' },
	{ label: 'MSK (Moscow)', value: 'Europe/Moscow' },
	{ label: 'AST / ADT (Halifax)', value: 'America/Halifax' },
	{ label: 'EST / EDT (New York, Miami, Toronto)', value: 'America/New_York' },
	{ label: 'CST / CDT (Chicago, Mexico City)', value: 'America/Chicago' },
	{ label: 'MST / MDT (Denver)', value: 'America/Denver' },
	{ label: 'PST / PDT (Los Angeles, Vancouver)', value: 'America/Los_Angeles' },
	{ label: 'SGT (Singapore)', value: 'Asia/Singapore' },
	{ label: 'JST (Tokyo)', value: 'Asia/Tokyo' },
	{ label: 'AEST / AEDT (Sydney, Melbourne)', value: 'Australia/Sydney' },
];
